export default __webpack_public_path__ + "static/brandsiteSketch-6590b082dc16d722de234ee03eb48e84.jpeg";